$( document ).ready(function() {
$('.togglecs').click(function() {
    $('.targetcs').toggle('0');
});   
});

$( document ).ready(function() {
$('.togacc').click(function() {
    $('.taracc').toggle('0');
});   
});

$( document ).ready(function() {
$('.togfcs').click(function() {
    $('.tarfcs').toggle('0');
});   
});

$( document ).ready(function() {
$(function() {
    //----- OPEN
    $('[data-popup-open]').on('click', function(e)  {
        var targeted_popup_class = jQuery(this).attr('data-popup-open');
        $('[data-popup="' + targeted_popup_class + '"]').fadeIn(350);
 
        e.preventDefault();
    });
 
    //----- CLOSE
    $('[data-popup-close]').on('click', function(e)  {
        var targeted_popup_class = jQuery(this).attr('data-popup-close');
        $('[data-popup="' + targeted_popup_class + '"]').fadeOut(350);
 
        e.preventDefault();
    });
});
  });

$( document ).ready(function() {
function removeDisabled() {
            let textsInput = document.querySelectorAll("input[type='radio']");
            textsInput.forEach((input) => {
                input.disabled = false;
            });
        }
});

$(document).ready(function(){
document.querySelector("#volume-switcher").onchange = function() {
  document.querySelector("#theplayer").muted = !this.checked;
}  
});

// $(document).ready(function(){
//   document.querySelector("#volume-switcherm").onchange = function() {
//   document.querySelector("#theplayerm").muted = !this.checked;
// } 
// });

